import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/o-grupo', label: 'O Grupo' },
    { path: '/empresas-do-grupo', label: 'Empresas' },
    { path: '/servicos', label: 'Serviços' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-12 lg:px-20">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer group">
            <div className="flex flex-col">
              <span className={`font-semibold text-sm tracking-wide transition-colors duration-300 ${
                isScrolled ? 'text-primary' : 'text-white'
              }`}>GRUPO PRIME</span>
            </div>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-5 py-2 text-[13px] font-medium tracking-wide transition-all duration-300 cursor-pointer ${
                  isScrolled
                    ? isActive(link.path)
                      ? 'text-primary'
                      : 'text-secondary hover:text-primary'
                    : isActive(link.path)
                      ? 'text-white'
                      : 'text-white/70 hover:text-white'
                }`}
              >
                {link.label}
                {isActive(link.path) && (
                  <motion.div
                    layoutId="activeNav"
                    className={`absolute bottom-0 left-5 right-5 h-0.5 ${
                      isScrolled ? 'bg-primary' : 'bg-white'
                    }`}
                    transition={{ duration: 0.3 }}
                  />
                )}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <Link
            to="/contato"
            className={`hidden md:flex items-center gap-2 px-6 py-2.5 text-[13px] font-semibold tracking-wide rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
              isScrolled
                ? 'bg-primary text-white hover:bg-primary/90'
                : 'bg-white text-primary hover:bg-white/90'
            }`}
          >
            Fale Conosco
            <i className="ri-arrow-right-up-line text-sm"></i>
          </Link>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
